<template>
  <div class="d-container w-[100%]">
    <a-affix>
      <div class="section_nav flex-row">
        <!--        <img v-if="!isPad" class="thumbnail_nav" @click="goHistory" referrerpolicy="no-referrer"-->
        <!--             src="../../assets/image/a_left.png" />-->
        <!--        <span class="text_nav">学生习题</span>-->
        <a-breadcrumb class="breadcrumb" v-if="!isPad">
          <a-breadcrumb-item style="font-size: 18px">
            <router-link :to="'/homePage'">首页</router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item style="font-size: 18px">
            学生习题
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </a-affix>

    <div class="substance">
      <div class="group_18 flex-row align-center justify-between">
        <div class="flex-row align-center">
          <span class="text_8">课文</span>
          <a-tree-select class="group_3_s" dropdownClassName="tree_drop_down" v-model="selCorpus"
                         :tree-data="treeData" tree-data-simple-mode allow-clear placeholder="请选择课文"
                         @select="selectCorpus">
            <template slot="title" slot-scope="item">
              <span :style="item.elementName === '1' ? 'color:#db5647': 'margin-left:20px'">
                {{ item.displayName }}
              </span>
            </template>
          </a-tree-select>
        </div>
        <div class="flex-row align-center">
          <span class="text_10">班级</span>
          <a-select v-model='className' class="group_4" @change="changeClass" allow-clear placeholder="请选择班级">
            <a-select-option :value="item.id" v-for="(item, index) in classData" :key="index">
              {{ item.className }}
            </a-select-option>
          </a-select>
        </div>
        <div class="flex-row align-center">
          <span class="text_12">状态</span>
          <a-select v-model="selStatus" class="group_5" allow-clear placeholder="请选择状态">
            <a-select-option :value="1"> 已提交</a-select-option>
            <a-select-option :value="0"> 未提交</a-select-option>
          </a-select>
        </div>

        <a-input-search class="input-search" placeholder="请输入要搜索内容" @search="onSearch"/>
      </div>
      <a-row>
        <a-table class="ac-table" :columns="columns" :dataSource="tableList" :pagination="false"
                 :rowKey="(record,index)=>{return index}" :loading="loading" @change="changeTable">
          <span class="taskNameColor" slot="styleName" slot-scope="styleName">
            {{ styleName }}
          </span>
          <span slot="isFinish" slot-scope="isFinish">
            {{ isFinish === 0 ? "未提交" : '已提交' }}
          </span>
          <span slot="commitDate" slot-scope="commitDate">
            {{ commitDate === null ? '-' : '' }}
          </span>
          <span slot="action" slot-scope="action, record">
            <span class="btnCheck" v-if="action===1" @click="watchDetail(record)">
              去查看
            </span>
            <span disabled class="correctDis" v-else>
              去查看
            </span>
          </span>
        </a-table>
        <div v-if="tableList.length!=0" style="text-align:center;margin-top:15px;">
          <a-config-provider>
            <a-pagination :page-size="pageSize" :current="pageNum" @change="changePageNum" :total='total'/>
          </a-config-provider>
        </div>
      </a-row>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, getCurrentInstance, onMounted, watch } from 'vue'
import format from 'utils/format.js'
import { decryptDes } from 'utils/crypto.js'

export default defineComponent({
  name: 'StudentsExercises',
  setup () {
    const { proxy } = getCurrentInstance()

    const tableList = ref([])
    const isPad = ref(false)
    const treeData = ref([])
    const selCorpus = ref(null) // 所选课文id
    const styleId = ref(null)
    const styleName = ref('')
    const access_token = ref('')
    const classId = ref(null)
    const className = ref(undefined)
    const classData = ref([])
    const loading = ref(false)
    const selStatus = ref(undefined)
    const total = ref(0)
    const searchText = ref(null)
    const pageSize = ref(10)
    const pageNum = ref(1)
    const columns = ref([
      {
        title: '序号',
        dataIndex: 'sequenceId',
        align: 'left',
        width: 100
      },
      {
        title: '姓名',
        dataIndex: 'userName',
        align: 'left',
        scopedSlots: { customRender: 'userName' }
      },
      {
        title: '课文',
        dataIndex: 'styleName',
        align: 'left',
        scopedSlots: { customRender: 'styleName' }
      },
      {
        title: '提交时间',
        dataIndex: 'createDate',
        align: 'left',
        width: 150,
        scopedSlots: { customRender: 'createDate' }
      },
      {
        title: '提交状态',
        dataIndex: 'isFinish',
        align: 'left',
        width: 150,
        scopedSlots: { customRender: 'isFinish' }
      },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'left',
        width: 100,
        scopedSlots: { customRender: 'action' }
      }
    ])

    watch(selCorpus, (nv, ov) => {
      for (let i = 0; i < treeData.value.length; i++) {
        const td = treeData.value[i]
        const data = td.children.find((o) => o.id == nv)
        if (data && data.displayName) {
          styleName.value = data.displayName
          break
        }
      }
      pageNum.value = 1
      styleId.value = nv
      getExercies()
    })

    watch(selStatus, (nv, ov) => {
      pageNum.value = 1
      selStatus.value = nv
      getExercies()
    })

    onMounted(() => {
      init()
      getBooks()
      getClassInfo()
    })

    const goHistory = () => {
      proxy.$router.push({ name: 'AccompanyStudy' })
    }

    const init = () => {
      if (proxy.$route.path.indexOf('/accompanyStudy') === 0) {
        // 网页端
        proxy.isPad = false
        proxy.userId = proxy.$getUserInfo().id
        proxy.token = localStorage.getItem('access_token')
      } else {
        // 手机端
        proxy.isPad = true
        const parameter = decryptDes(proxy.$route.params.parameter)
        const params = parameter.split('&')
        proxy.token = params[0]
        proxy.userId = params[1]
        localStorage.setItem('access_token', params[0])
      }
    }

    const getClassInfo = () => {
      // 班级列表
      proxy
        .$fetch({
          url: proxy.$httpConfig.getTeaClassListByUserId,
          body: {
            token: proxy.token,
            userId: proxy.userId
          }
        })
        .loading(
          () => (loading.value = true),
          () => (loading.value = false)
        )
        .done((res) => {
          if (res && res.success && res.resultCode === '0') {
            classData.value = res.resultData
            getExercies()
          }
        })
    }
    const changeClass = (e) => {
      // 切换班级
      pageNum.value = 1
      className.value = undefined
      classId.value = null
      const newData = classData.value.find((item) => {
        return item.id == e
      })
      if (newData) {
        className.value = newData.className
        sessionStorage.setItem('className', newData.className)
        sessionStorage.setItem('classId', e)
        classId.value = sessionStorage.getItem('classId')
      }
      getExercies()
    }

    const getBooks = () => {
      // 获取书籍列表
      proxy
        .$fetch({
          url: proxy.$httpConfig.getBookStyleTierList,
          body: {
            token: proxy.token,
            userId: proxy.userId
          }
        })
        .done((res) => {
          // console.log(res);
          if (res && res.success && res.resultData) {
            for (let i = 0; i < res.resultData.length; i++) {
              const element = res.resultData[i]
              const data = {
                id: 'b' + element.id,
                pId: -1,
                bookId: element.id,
                value: element.name,
                title: element.name,
                selectable: false,
                children: []
              }
              if (element.children) {
                element.children.forEach((e1) => {
                  data.children.push({
                    id: e1.id,
                    pId: data.id,
                    value: e1.id,
                    displayName: e1.name,
                    isLeaf: true,
                    elementName: '1',
                    selectable: false,
                    scopedSlots: {
                      title: 'title'
                    }
                  })

                  e1.children.forEach((ec1) => {
                    data.children.push({
                      id: ec1.id,
                      pId: data.id,
                      value: ec1.id,
                      displayName: ec1.name,
                      isLeaf: true,
                      elementName: '2',
                      selectable: true,
                      scopedSlots: {
                        title: 'title'
                      }
                    })
                  })
                })
              }

              treeData.value.push(data)
            }
          }
        })
    }
    const selectCorpus = (value, node) => {
      // console.log('s', value, node);
      styleName.value = node.dataRef.displayName
    }
    const changeTable = () => {
    }

    const onSearch = (key) => {
      searchText.value = key
      pageNum.value = 1
      getExercies()
    }
    const changePageNum = (num) => {
      pageNum.value = num
      sessionStorage.setItem('studentExercisesPageNumber', pageNum.value)
      getExercies()
    }
    const getExercies = () => {
      const param = {
        styleId: styleId.value,
        classId: classId.value,
        status: selStatus.value,
        name: searchText.value,
        pageSize: pageSize.value,
        pageNum: pageNum.value
        // userId: this.userId,
      }
      proxy
        .$fetch({
          url: proxy.$httpConfig.getTeaQuExam,
          body: param
        })
        .loading(
          () => (loading.value = true),
          () => (loading.value = false)
        )
        .done((res) => {
          tableList.value = []
          if (res && res.success && res.resultCode == 0) {
            total.value = res.resultData.total
            // selCorpus.value = this.styleId;
            if (res.resultData && res.resultData.list.length > 0) {
              let idx = 1 + (pageNum.value == null ? 0 : pageSize.value * (pageNum.value - 1))
              res.resultData.list.forEach((item) => {
                tableList.value.push({
                  sequenceId: idx++,
                  id: item.id,
                  userId: item.userId,
                  userName: item.userName,
                  styleId: item.styleId,
                  styleName: item.styleName,
                  isFinish: item.isFinish,
                  createDate: item.createDate ? format.formatDayTime(item.createDate) : '-',
                  action: item.isFinish
                })
              })
            }
          }
        })
    }

    // 查看习题详情
    const watchDetail = (record) => {
      console.log(record)
      const obj = {
        id: record.id,
        styleId: record.styleId,
        userId: record.userId,
        access_token: proxy.token
      }
      // proxy.$router.push({
      //   name: 'StudentsExercisesDetail',
      //   params: obj
      // });
      console.log(!proxy.isPad)
      if (!proxy.isPad) {
        // 网页端
        console.log(obj)
        proxy.$router.push({
          name: 'StudentsExercisesDetail',
          params: obj
        })
      } else {
        // 手机端
        console.log(JSON.stringify(obj))
        localStorage.setItem('StudentsExercisesPhone', JSON.stringify(obj))
        // proxy.$router.push({
        //   name: 'StudentsExercisesDetail',
        //   params: obj
        // })
        // proxy.$router.push({ name: 'StudentsExercisesDetail' })
        const rp = '/studentsExercisesDetail/' + proxy.$route.params.parameter
        proxy.$router.push({ path: rp })
        // proxy.$router.push({ path: '/studentsExercisesDetail' })
      }
    }

    return {
      columns,
      isPad,
      treeData,
      tableList,
      styleName,
      selCorpus,
      className,
      classData,
      loading,
      selStatus,
      total,
      searchText,
      pageSize,
      pageNum,

      onSearch,
      getBooks,
      goHistory,
      changeClass,
      selectCorpus,
      changeTable,
      changePageNum,
      watchDetail
    }
  }
})
</script>

<style scoped>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';
</style>
<style lang="less" scoped>
@import '../../assets/homework.less';
</style>
